import { TabsList, TabsTrigger } from '@/components/ui/tabs'
import { Badge } from '@/components/ui/badge'
import { useTotalUnreadCount } from '@/services/notification'

export const DashboardHomeHeader = () => {
  const { data: totalUnreadCount = 0, isLoading } = useTotalUnreadCount()

  return (
    <div className="mb-4 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
      <TabsList data-testid="dashboard-tabs">
        <TabsTrigger value="overview" data-testid="overview-tab">
          Overview
        </TabsTrigger>
        <TabsTrigger value="analytics" data-testid="analytics-tab">
          Analytics
        </TabsTrigger>
        <TabsTrigger
          value="notifications"
          className="relative"
          data-testid="notifications-tab"
        >
          Notifications
          {!isLoading && totalUnreadCount > 0 && (
            <Badge
              className="absolute -top-2 -right-4 bg-destructive text-destructive-foreground rounded-full px-2 py-1 text-xs"
              data-testid="notifications-tab-badge"
            >
              {totalUnreadCount}
            </Badge>
          )}
        </TabsTrigger>
      </TabsList>
    </div>
  )
}
